/** The record types an organisation can export; the same values as the importer's entities. */
export type DataExportEntity = 'contact' | 'company' | 'candidate';

/** One column of the file: the importer's field key, `cf:<config id>`, or an `extra:` key. */
export interface DataExportColumn {
  key: string;
  header: string;
}

export interface DataExportRequest {
  entity: DataExportEntity;
  /** Only this list's members. Left out for every record of the type. */
  list_id?: string;
  fields: DataExportColumn[];
  /** IANA zone the created and updated dates are written in. */
  time_zone?: string;
}

export interface DataExportProgress {
  /** Rows received so far. Approximate while the file is arriving, exact at the end. */
  written: number;
  total: number;
}

export interface DataExportResult {
  blob: Blob;
  fileName: string;
  total: number;
}

/** An export the server refused, with its business error code when it sent one. */
export class DataExportError extends Error {
  constructor(
    public readonly status: number,
    public readonly errorCode?: string,
    public readonly context?: Record<string, unknown>
  ) {
    super(`Export failed with status ${status}`);
  }
}
